const root = process.env.API_ROOT
const aws = "'https://bbbot-image.s3.cn-northwest-1.amazonaws.com.cn/'"
// console.log('api.index.js..root', root)
export default {
  root,
  aws
}



// WEBPACK FOOTER //
// ./src/api/index.js